import React from 'react';
import injectSheet from 'react-jss';
import { Spin } from 'antd';
import { classesPropType } from '../prop-types';

const styles = {
  container: ({ cover }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: cover ? '100%' : 'auto',
    flex: cover ? 1 : 'initial',
  }),
};

function Loading({ classes }) {
  return (
    <div className={classes.container}>
      <Spin size="large" />
    </div>
  );
}

Loading.propTypes = {
  classes: classesPropType.isRequired,
};

export default injectSheet(styles)(Loading);
